/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocks_Market_Indicators_Treasury_Etf_LabelInputs */

const en_stocks_market_indicators_treasury_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Treasury_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20+ Year Treasury ETF`)
};

const de_stocks_market_indicators_treasury_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Treasury_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20+ Year Treasury ETF`)
};

const pt_br2_stocks_market_indicators_treasury_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Treasury_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20+ Year Treasury ETF`)
};

const tr_stocks_market_indicators_treasury_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Treasury_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20+ Year Treasury ETF`)
};

const zh_cn2_stocks_market_indicators_treasury_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Treasury_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 年期以上美国国债 ETF`)
};

const zh_hk2_stocks_market_indicators_treasury_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Treasury_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 年期以上美國國債 ETF`)
};

const ko_kr2_stocks_market_indicators_treasury_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Treasury_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20년 이상 국채 ETF`)
};

const ru_ru2_stocks_market_indicators_treasury_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Treasury_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETF на гособлигации США 20+ лет`)
};

const es_419_stocks_market_indicators_treasury_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Treasury_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETF de bonos del Tesoro a más de 20 años`)
};

/**
* | output |
* | --- |
* | "20+ Year Treasury ETF" |
*
* @param {Stocks_Market_Indicators_Treasury_Etf_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const stocks_market_indicators_treasury_etf_label = /** @type {((inputs?: Stocks_Market_Indicators_Treasury_Etf_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocks_Market_Indicators_Treasury_Etf_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stocks_market_indicators_treasury_etf_label(inputs)
	if (locale === "de") return de_stocks_market_indicators_treasury_etf_label(inputs)
	if (locale === "pt-BR") return pt_br2_stocks_market_indicators_treasury_etf_label(inputs)
	if (locale === "tr") return tr_stocks_market_indicators_treasury_etf_label(inputs)
	if (locale === "zh-CN") return zh_cn2_stocks_market_indicators_treasury_etf_label(inputs)
	if (locale === "zh-HK") return zh_hk2_stocks_market_indicators_treasury_etf_label(inputs)
	if (locale === "ko-KR") return ko_kr2_stocks_market_indicators_treasury_etf_label(inputs)
	if (locale === "ru-RU") return ru_ru2_stocks_market_indicators_treasury_etf_label(inputs)
	return es_419_stocks_market_indicators_treasury_etf_label(inputs)
});